var $9bd424988b5bc2dd$exports = {};
$9bd424988b5bc2dd$exports = {
    "collapse": `Sak\u{13C}aut`,
    "expand": `Izv\u{113}rst`
};


export {$9bd424988b5bc2dd$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
